import React, { useImperativeHandle, useRef } from 'react';

interface TextInput {
    focus?: () => any;
    setText: (text: string) => any;
    value?: string
}

interface TextInputProps {
    label?: string;
    required?: boolean
    placeholder?: string
    onChange?: (value: string) => any;
    icon?: () => JSX.Element
    type?: React.HTMLInputTypeAttribute;
    center?: boolean;
    onKeyDown?: React.KeyboardEventHandler<HTMLInputElement>;
    maxLength?: number;
    height?: number;
    fontSize?: number;
    px?: number;
    error?: boolean;
    autoFocus?: boolean;
    sm?: boolean;
    value?: string | number;
    border?: boolean,
    inputProps?: React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>
    id?: string;
    name?: string;
}

const TextInput = React.forwardRef<TextInput, TextInputProps>(({ label,
    required,
    placeholder,
    onChange,
    icon,
    center,
    type,
    onKeyDown,
    maxLength,
    height,
    fontSize,
    px,
    error,
    autoFocus,
    sm,
    value,
    border,
    inputProps = {},
    id,
    name
}, ref) => {

    const inputRef = useRef<HTMLInputElement>(null);

    useImperativeHandle(ref, () => {
        return {
            focus: () => inputRef.current?.focus(),
            setText: (text: string) => {
                if (inputRef.current)
                    inputRef.current.value = text;
            },
            value: inputRef.current?.value
        }
    }, [inputRef.current?.value, inputRef.current?.focus]);

    const Icon = icon;

    return (
        <div className='flex flex-col space-y-3 font-Poppins flex-1 relative'>
            {label && <label className='font-semibold text-base text-light-primary'>{label}</label>}
            <div className='relative w-full'>
                {Icon && <div className='absolute left-3 z-10 my-3'>
                    <Icon />
                </div>}
                <input
                    defaultValue={value}
                    autoFocus={autoFocus}
                    style={{ height, fontSize, paddingInline: icon ? 46 : px || 16 }}
                    onKeyDown={onKeyDown}
                    maxLength={maxLength}
                    type={type}
                    id={id}
                    name={name}
                    className={`font-Inter font-semibold w-full
                focus:outline-none caret-logo focus:ring-logo focus:border-logo border border-light rounded-[12px] ${sm ? 'py-1.5' : 'py-3'}  bg-light placeholder-[#9A9FA5] placeholder:text-base text-base relative
                ${center && 'text-center'}
                ${error && 'text-[#FF6A55] bg-[#FFBC9940]/25'}
                ${border && 'focus:border-none'}
                `}
                    onChange={(e) => onChange && onChange(e.target.value)}
                    required={required}
                    placeholder={placeholder}
                    ref={inputRef}

                    {...inputProps}

                />
            </div>
        </div>
    );

});

export default TextInput;